// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section7 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section seven'>
       <div className="wrapper">
       <h2>Das weiss man zu Hundebissen</h2>
          <div className='txt'>
            <p>
            Eine nationale Datenbank zu Beissvorfällen gibt es nicht. Verletzt ein Hund Menschen oder Tiere erheblich oder ist das Tier besonders aggressiv, muss das aber gemeldet werden, in der Regel dem kantonalen Veterinäramt. Eine <Stink href='https://www.srf.ch/news/schweiz/zahlen-der-kantone-hundebisse-in-der-schweiz-seit-2016-stark-angestiegen'>Umfrage von SRF</Stink> bei allen Kantonen zeigte 2019, dass es schweizweit zu mehr als 7000 Vorfällen mit Hunden kam. Das waren 19 Prozent mehr als noch 2016 – dem letzten Jahr, in dem noch ein nationales Kursobligatorium für Hundehalterinnen und Hundehalter bestand.
            </p>
            <p>
              Heute müssen Herrchen und Frauchen längst nicht überall in den Kurs. In manchen Kantonen gilt eine Pflicht, wenn es der erste Hund ist, in anderen bei Tieren mit einem erhöhten Gefährdungspotenzial oder ab einer bestimmten Grösse. Die Hälfte aller Kantone kennt laut <Stink href='https://www.srf.ch/news/schweiz/wirrwarr-bei-hunde-regeln-obligatorische-kurse-sollen-hundebisse-verhindern'>SRF</Stink> gar kein Obligatorium mehr.
            </p>
          </div>
          <div className="chart">
            <AutofitIFrame
              src={'https://datawrapper.dwcdn.net/Y0dqu/' + '?dark=' + String(this.props.colorMode === 'dark')}
            />
          </div>        
          <div className='txt'>
            <p>
              Die Abschaffung des nationalen Kursobligatoriums könnte zu mehr Bissen geführt haben. Allein an der Zunahme der Anzahl Hunde in der Schweiz kann es nämlich nicht liegen: Diese stieg von Anfang 2016 bis Ende 2019 nur um 5 Prozent.
            </p>
            <p>
              Denkbar ist auch, dass es mittlerweile eine höhere Sensibilität für entsprechende Meldungen gibt. Verschiedene Kantone führen zur Vermeidung von Hundebissen Präventionskampagnen und Schulprojekte durch. Denn Kinder haben ein besonders hohes Risiko, gebissen zu werden – übrigens vor allem von <Stink href='920824910312'>kleinen Hunden, die gemäss Fachleuten aggressiver sind</Stink>.
            </p>
          </div>
      </div>
    </div>
  }
}
